import { triggerEarlyDocumentsVehicleSeenEvent } from 'Services/analytics/events';

export const TAG_NAME = 'earlyDocuments';

export const EARLY_DOCUMENTS_EVENTS = {
	[TAG_NAME]: triggerEarlyDocumentsVehicleSeenEvent,
};
